import { createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { usePost: useSubmitReview } = createPostAPI({
  getURL: reviewId => `${BASE_URL}/teacher-classroom-reviews/${reviewId}/`,
});

export { useSubmitReview };
